function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { defineComponent, getCurrentInstance, ref, computed, unref, nextTick, onMounted, h, resolveDynamicComponent } from 'vue';
import '../../../../utils/index.mjs';
import '../../../../hooks/index.mjs';
import ScrollBar from '../components/scrollbar.mjs';
import { useGridWheel } from '../hooks/use-grid-wheel.mjs';
import { useCache } from '../hooks/use-cache.mjs';
import { virtualizedGridProps } from '../props.mjs';
import { isRTL, getRTLOffsetType, getScrollDir } from '../utils.mjs';
import { ITEM_RENDER_EVT, SCROLL_EVT, FORWARD, BACKWARD, RTL_OFFSET_POS_DESC, RTL_OFFSET_NAG, AUTO_ALIGNMENT, RTL, RTL_OFFSET_POS_ASC } from '../defaults.mjs';
import { useNamespace } from '../../../../hooks/use-namespace/index.mjs';
import { isNumber } from '../../../../utils/types.mjs';
import { getScrollBarWidth } from '../../../../utils/dom/scroll.mjs';
import { hasOwn, isString } from '@vue/shared';
import { isClient } from '@vueuse/core';
const createGrid = _ref => {
  let name = _ref.name,
    clearCache = _ref.clearCache,
    getColumnPosition = _ref.getColumnPosition,
    getColumnStartIndexForOffset = _ref.getColumnStartIndexForOffset,
    getColumnStopIndexForStartIndex = _ref.getColumnStopIndexForStartIndex,
    getEstimatedTotalHeight = _ref.getEstimatedTotalHeight,
    getEstimatedTotalWidth = _ref.getEstimatedTotalWidth,
    getColumnOffset = _ref.getColumnOffset,
    getRowOffset = _ref.getRowOffset,
    getRowPosition = _ref.getRowPosition,
    getRowStartIndexForOffset = _ref.getRowStartIndexForOffset,
    getRowStopIndexForStartIndex = _ref.getRowStopIndexForStartIndex,
    initCache = _ref.initCache,
    injectToInstance = _ref.injectToInstance,
    validateProps = _ref.validateProps;
  return defineComponent({
    name: name != null ? name : "ElVirtualList",
    props: virtualizedGridProps,
    emits: [ITEM_RENDER_EVT, SCROLL_EVT],
    setup(props, _ref2) {
      let emit = _ref2.emit,
        expose = _ref2.expose,
        slots = _ref2.slots;
      const ns = useNamespace("vl");
      validateProps(props);
      const instance = getCurrentInstance();
      const cache = ref(initCache(props, instance));
      injectToInstance == null ? void 0 : injectToInstance(instance, cache);
      const windowRef = ref();
      const hScrollbar = ref();
      const vScrollbar = ref();
      const innerRef = ref(null);
      const states = ref({
        isScrolling: false,
        scrollLeft: isNumber(props.initScrollLeft) ? props.initScrollLeft : 0,
        scrollTop: isNumber(props.initScrollTop) ? props.initScrollTop : 0,
        updateRequested: false,
        xAxisScrollDir: FORWARD,
        yAxisScrollDir: FORWARD
      });
      const getItemStyleCache = useCache();
      const parsedHeight = computed(() => Number.parseInt(`${props.height}`, 10));
      const parsedWidth = computed(() => Number.parseInt(`${props.width}`, 10));
      const columnsToRender = computed(() => {
        const totalColumn = props.totalColumn,
          totalRow = props.totalRow,
          columnCache = props.columnCache;
        const _unref = unref(states),
          isScrolling = _unref.isScrolling,
          xAxisScrollDir = _unref.xAxisScrollDir,
          scrollLeft = _unref.scrollLeft;
        if (totalColumn === 0 || totalRow === 0) {
          return [0, 0, 0, 0];
        }
        const startIndex = getColumnStartIndexForOffset(props, scrollLeft, unref(cache));
        const stopIndex = getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, unref(cache));
        const cacheBackward = !isScrolling || xAxisScrollDir === BACKWARD ? Math.max(1, columnCache) : 1;
        const cacheForward = !isScrolling || xAxisScrollDir === FORWARD ? Math.max(1, columnCache) : 1;
        return [Math.max(0, startIndex - cacheBackward), Math.max(0, Math.min(totalColumn - 1, stopIndex + cacheForward)), startIndex, stopIndex];
      });
      const rowsToRender = computed(() => {
        const totalColumn = props.totalColumn,
          totalRow = props.totalRow,
          rowCache = props.rowCache;
        const _unref2 = unref(states),
          isScrolling = _unref2.isScrolling,
          yAxisScrollDir = _unref2.yAxisScrollDir,
          scrollTop = _unref2.scrollTop;
        if (totalColumn === 0 || totalRow === 0) {
          return [0, 0, 0, 0];
        }
        const startIndex = getRowStartIndexForOffset(props, scrollTop, unref(cache));
        const stopIndex = getRowStopIndexForStartIndex(props, startIndex, scrollTop, unref(cache));
        const cacheBackward = !isScrolling || yAxisScrollDir === BACKWARD ? Math.max(1, rowCache) : 1;
        const cacheForward = !isScrolling || yAxisScrollDir === FORWARD ? Math.max(1, rowCache) : 1;
        return [Math.max(0, startIndex - cacheBackward), Math.max(0, Math.min(totalRow - 1, stopIndex + cacheForward)), startIndex, stopIndex];
      });
      const estimatedTotalHeight = computed(() => getEstimatedTotalHeight(props, unref(cache)));
      const estimatedTotalWidth = computed(() => getEstimatedTotalWidth(props, unref(cache)));
      const windowStyle = computed(() => {
        var _a;
        return [{
          position: "relative",
          overflow: "hidden",
          WebkitOverflowScrolling: "touch",
          willChange: "transform"
        }, {
          direction: props.direction,
          height: isNumber(props.height) ? `${props.height}px` : props.height,
          width: isNumber(props.width) ? `${props.width}px` : props.width
        }, (_a = props.style) != null ? _a : {}];
      });
      const innerStyle = computed(() => {
        const width = `${unref(estimatedTotalWidth)}px`;
        const height = `${unref(estimatedTotalHeight)}px`;
        return {
          height,
          pointerEvents: unref(states).isScrolling ? "none" : void 0,
          width
        };
      });
      const emitEvents = () => {
        const totalColumn = props.totalColumn,
          totalRow = props.totalRow;
        if (totalColumn > 0 && totalRow > 0) {
          const _unref3 = unref(columnsToRender),
            _unref4 = _slicedToArray(_unref3, 4),
            columnCacheStart = _unref4[0],
            columnCacheEnd = _unref4[1],
            columnVisibleStart = _unref4[2],
            columnVisibleEnd = _unref4[3];
          const _unref5 = unref(rowsToRender),
            _unref6 = _slicedToArray(_unref5, 4),
            rowCacheStart = _unref6[0],
            rowCacheEnd = _unref6[1],
            rowVisibleStart = _unref6[2],
            rowVisibleEnd = _unref6[3];
          emit(ITEM_RENDER_EVT, {
            columnCacheStart,
            columnCacheEnd,
            rowCacheStart,
            rowCacheEnd,
            columnVisibleStart,
            columnVisibleEnd,
            rowVisibleStart,
            rowVisibleEnd
          });
        }
        const _unref7 = unref(states),
          scrollLeft = _unref7.scrollLeft,
          scrollTop = _unref7.scrollTop,
          updateRequested = _unref7.updateRequested,
          xAxisScrollDir = _unref7.xAxisScrollDir,
          yAxisScrollDir = _unref7.yAxisScrollDir;
        emit(SCROLL_EVT, {
          xAxisScrollDir,
          scrollLeft,
          yAxisScrollDir,
          scrollTop,
          updateRequested
        });
      };
      const onScroll = e => {
        const _e$currentTarget = e.currentTarget,
          clientHeight = _e$currentTarget.clientHeight,
          clientWidth = _e$currentTarget.clientWidth,
          scrollHeight = _e$currentTarget.scrollHeight,
          scrollLeft = _e$currentTarget.scrollLeft,
          scrollTop = _e$currentTarget.scrollTop,
          scrollWidth = _e$currentTarget.scrollWidth;
        const _states = unref(states);
        if (_states.scrollTop === scrollTop && _states.scrollLeft === scrollLeft) {
          return;
        }
        let _scrollLeft = scrollLeft;
        if (isRTL(props.direction)) {
          switch (getRTLOffsetType()) {
            case RTL_OFFSET_NAG:
              _scrollLeft = -scrollLeft;
              break;
            case RTL_OFFSET_POS_DESC:
              _scrollLeft = scrollWidth - clientWidth - scrollLeft;
              break;
          }
        }
        states.value = _objectSpread(_objectSpread({}, _states), {}, {
          isScrolling: true,
          scrollLeft: _scrollLeft,
          scrollTop: Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight)),
          updateRequested: true,
          xAxisScrollDir: getScrollDir(_states.scrollLeft, _scrollLeft),
          yAxisScrollDir: getScrollDir(_states.scrollTop, scrollTop)
        });
        nextTick(() => resetIsScrolling());
        onUpdated();
        emitEvents();
      };
      const onVerticalScroll = (distance, totalSteps) => {
        const height = unref(parsedHeight);
        const offset = (estimatedTotalHeight.value - height) / totalSteps * distance;
        scrollTo({
          scrollTop: Math.min(estimatedTotalHeight.value - height, offset)
        });
      };
      const onHorizontalScroll = (distance, totalSteps) => {
        const width = unref(parsedWidth);
        const offset = (estimatedTotalWidth.value - width) / totalSteps * distance;
        scrollTo({
          scrollLeft: Math.min(estimatedTotalWidth.value - width, offset)
        });
      };
      const _useGridWheel = useGridWheel({
          atXStartEdge: computed(() => states.value.scrollLeft <= 0),
          atXEndEdge: computed(() => states.value.scrollLeft >= estimatedTotalWidth.value - unref(parsedWidth)),
          atYStartEdge: computed(() => states.value.scrollTop <= 0),
          atYEndEdge: computed(() => states.value.scrollTop >= estimatedTotalHeight.value - unref(parsedHeight))
        }, (x, y) => {
          var _a, _b, _c, _d;
          (_b = (_a = hScrollbar.value) == null ? void 0 : _a.onMouseUp) == null ? void 0 : _b.call(_a);
          (_d = (_c = vScrollbar.value) == null ? void 0 : _c.onMouseUp) == null ? void 0 : _d.call(_c);
          const width = unref(parsedWidth);
          const height = unref(parsedHeight);
          scrollTo({
            scrollLeft: Math.min(states.value.scrollLeft + x, estimatedTotalWidth.value - width),
            scrollTop: Math.min(states.value.scrollTop + y, estimatedTotalHeight.value - height)
          });
        }),
        onWheel = _useGridWheel.onWheel;
      const scrollTo = _ref3 => {
        let _ref3$scrollLeft = _ref3.scrollLeft,
          scrollLeft = _ref3$scrollLeft === void 0 ? states.value.scrollLeft : _ref3$scrollLeft,
          _ref3$scrollTop = _ref3.scrollTop,
          scrollTop = _ref3$scrollTop === void 0 ? states.value.scrollTop : _ref3$scrollTop;
        scrollLeft = Math.max(scrollLeft, 0);
        scrollTop = Math.max(scrollTop, 0);
        const _states = unref(states);
        if (scrollTop === _states.scrollTop && scrollLeft === _states.scrollLeft) {
          return;
        }
        states.value = _objectSpread(_objectSpread({}, _states), {}, {
          xAxisScrollDir: getScrollDir(_states.scrollLeft, scrollLeft),
          yAxisScrollDir: getScrollDir(_states.scrollTop, scrollTop),
          scrollLeft,
          scrollTop,
          updateRequested: true
        });
        nextTick(() => resetIsScrolling());
        onUpdated();
        emitEvents();
      };
      const scrollToItem = function () {
        let rowIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let columnIdx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let alignment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : AUTO_ALIGNMENT;
        const _states = unref(states);
        columnIdx = Math.max(0, Math.min(columnIdx, props.totalColumn - 1));
        rowIndex = Math.max(0, Math.min(rowIndex, props.totalRow - 1));
        const scrollBarWidth = getScrollBarWidth(ns.namespace.value);
        const _cache = unref(cache);
        const estimatedHeight = getEstimatedTotalHeight(props, _cache);
        const estimatedWidth = getEstimatedTotalWidth(props, _cache);
        scrollTo({
          scrollLeft: getColumnOffset(props, columnIdx, alignment, _states.scrollLeft, _cache, estimatedWidth > props.width ? scrollBarWidth : 0),
          scrollTop: getRowOffset(props, rowIndex, alignment, _states.scrollTop, _cache, estimatedHeight > props.height ? scrollBarWidth : 0)
        });
      };
      const getItemStyle = (rowIndex, columnIndex) => {
        const columnWidth = props.columnWidth,
          direction = props.direction,
          rowHeight = props.rowHeight;
        const itemStyleCache = getItemStyleCache.value(clearCache && columnWidth, clearCache && rowHeight, clearCache && direction);
        const key = `${rowIndex},${columnIndex}`;
        if (hasOwn(itemStyleCache, key)) {
          return itemStyleCache[key];
        } else {
          const _getColumnPosition = getColumnPosition(props, columnIndex, unref(cache)),
            _getColumnPosition2 = _slicedToArray(_getColumnPosition, 2),
            left = _getColumnPosition2[1];
          const _cache = unref(cache);
          const rtl = isRTL(direction);
          const _getRowPosition = getRowPosition(props, rowIndex, _cache),
            _getRowPosition2 = _slicedToArray(_getRowPosition, 2),
            height = _getRowPosition2[0],
            top = _getRowPosition2[1];
          const _getColumnPosition3 = getColumnPosition(props, columnIndex, _cache),
            _getColumnPosition4 = _slicedToArray(_getColumnPosition3, 1),
            width = _getColumnPosition4[0];
          itemStyleCache[key] = {
            position: "absolute",
            left: rtl ? void 0 : `${left}px`,
            right: rtl ? `${left}px` : void 0,
            top: `${top}px`,
            height: `${height}px`,
            width: `${width}px`
          };
          return itemStyleCache[key];
        }
      };
      const resetIsScrolling = () => {
        states.value.isScrolling = false;
        nextTick(() => {
          getItemStyleCache.value(-1, null, null);
        });
      };
      onMounted(() => {
        if (!isClient) return;
        const initScrollLeft = props.initScrollLeft,
          initScrollTop = props.initScrollTop;
        const windowElement = unref(windowRef);
        if (windowElement) {
          if (isNumber(initScrollLeft)) {
            windowElement.scrollLeft = initScrollLeft;
          }
          if (isNumber(initScrollTop)) {
            windowElement.scrollTop = initScrollTop;
          }
        }
        emitEvents();
      });
      const onUpdated = () => {
        const direction = props.direction;
        const _unref8 = unref(states),
          scrollLeft = _unref8.scrollLeft,
          scrollTop = _unref8.scrollTop,
          updateRequested = _unref8.updateRequested;
        const windowElement = unref(windowRef);
        if (updateRequested && windowElement) {
          if (direction === RTL) {
            switch (getRTLOffsetType()) {
              case RTL_OFFSET_NAG:
                {
                  windowElement.scrollLeft = -scrollLeft;
                  break;
                }
              case RTL_OFFSET_POS_ASC:
                {
                  windowElement.scrollLeft = scrollLeft;
                  break;
                }
              default:
                {
                  const clientWidth = windowElement.clientWidth,
                    scrollWidth = windowElement.scrollWidth;
                  windowElement.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                  break;
                }
            }
          } else {
            windowElement.scrollLeft = Math.max(0, scrollLeft);
          }
          windowElement.scrollTop = Math.max(0, scrollTop);
        }
      };
      const _instance$proxy = instance.proxy,
        resetAfterColumnIndex = _instance$proxy.resetAfterColumnIndex,
        resetAfterRowIndex = _instance$proxy.resetAfterRowIndex,
        resetAfter = _instance$proxy.resetAfter;
      expose({
        windowRef,
        innerRef,
        getItemStyleCache,
        scrollTo,
        scrollToItem,
        states,
        resetAfterColumnIndex,
        resetAfterRowIndex,
        resetAfter
      });
      const renderScrollbars = () => {
        const scrollbarAlwaysOn = props.scrollbarAlwaysOn,
          scrollbarStartGap = props.scrollbarStartGap,
          scrollbarEndGap = props.scrollbarEndGap,
          totalColumn = props.totalColumn,
          totalRow = props.totalRow;
        const width = unref(parsedWidth);
        const height = unref(parsedHeight);
        const estimatedWidth = unref(estimatedTotalWidth);
        const estimatedHeight = unref(estimatedTotalHeight);
        const _unref9 = unref(states),
          scrollLeft = _unref9.scrollLeft,
          scrollTop = _unref9.scrollTop;
        const horizontalScrollbar = h(ScrollBar, {
          ref: hScrollbar,
          alwaysOn: scrollbarAlwaysOn,
          startGap: scrollbarStartGap,
          endGap: scrollbarEndGap,
          class: ns.e("horizontal"),
          clientSize: width,
          layout: "horizontal",
          onScroll: onHorizontalScroll,
          ratio: width * 100 / estimatedWidth,
          scrollFrom: scrollLeft / (estimatedWidth - width),
          total: totalRow,
          visible: true
        });
        const verticalScrollbar = h(ScrollBar, {
          ref: vScrollbar,
          alwaysOn: scrollbarAlwaysOn,
          startGap: scrollbarStartGap,
          endGap: scrollbarEndGap,
          class: ns.e("vertical"),
          clientSize: height,
          layout: "vertical",
          onScroll: onVerticalScroll,
          ratio: height * 100 / estimatedHeight,
          scrollFrom: scrollTop / (estimatedHeight - height),
          total: totalColumn,
          visible: true
        });
        return {
          horizontalScrollbar,
          verticalScrollbar
        };
      };
      const renderItems = () => {
        var _a;
        const _unref10 = unref(columnsToRender),
          _unref11 = _slicedToArray(_unref10, 2),
          columnStart = _unref11[0],
          columnEnd = _unref11[1];
        const _unref12 = unref(rowsToRender),
          _unref13 = _slicedToArray(_unref12, 2),
          rowStart = _unref13[0],
          rowEnd = _unref13[1];
        const data = props.data,
          totalColumn = props.totalColumn,
          totalRow = props.totalRow,
          useIsScrolling = props.useIsScrolling,
          itemKey = props.itemKey;
        const children = [];
        if (totalRow > 0 && totalColumn > 0) {
          for (let row = rowStart; row <= rowEnd; row++) {
            for (let column = columnStart; column <= columnEnd; column++) {
              children.push((_a = slots.default) == null ? void 0 : _a.call(slots, {
                columnIndex: column,
                data,
                key: itemKey({
                  columnIndex: column,
                  data,
                  rowIndex: row
                }),
                isScrolling: useIsScrolling ? unref(states).isScrolling : void 0,
                style: getItemStyle(row, column),
                rowIndex: row
              }));
            }
          }
        }
        return children;
      };
      const renderInner = () => {
        const Inner = resolveDynamicComponent(props.innerElement);
        const children = renderItems();
        return [h(Inner, {
          style: unref(innerStyle),
          ref: innerRef
        }, !isString(Inner) ? {
          default: () => children
        } : children)];
      };
      const renderWindow = () => {
        const Container = resolveDynamicComponent(props.containerElement);
        const _renderScrollbars = renderScrollbars(),
          horizontalScrollbar = _renderScrollbars.horizontalScrollbar,
          verticalScrollbar = _renderScrollbars.verticalScrollbar;
        const Inner = renderInner();
        return h("div", {
          key: 0,
          class: ns.e("wrapper"),
          role: props.role
        }, [h(Container, {
          class: props.className,
          style: unref(windowStyle),
          onScroll,
          onWheel,
          ref: windowRef
        }, !isString(Container) ? {
          default: () => Inner
        } : Inner), horizontalScrollbar, verticalScrollbar]);
      };
      return renderWindow;
    }
  });
};
export { createGrid as default };